import { FeatureCard } from '@components/ui/cards/FeatureCard';
import { getReferralRewardText, useReferralsQuery } from '@features/referrals';
import { useReferralInfo } from '@features/user';
import { ContentCopy } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { useEventTracking } from '@services/statsig';
import { useSnackbar } from 'notistack';

/**
 * ShareJotPsychCard Component
 * Dashboard card for sharing referral code - spans full width at bottom
 */
export const ShareJotPsychCard = () => {
  const referralInfo = useReferralInfo();
  const { data: referralData } = useReferralsQuery();
  const rewardText = getReferralRewardText(referralData?.referrer_reward_amount, referralData?.signup_discount_amount);
  const { enqueueSnackbar } = useSnackbar();
  const { dashboard } = useEventTracking();

  // Only render if referral info exists
  if (!referralInfo?.referral_code) return null;

  const handleCopy = () => {
    const signupUrl = `${import.meta.env.VITE_MAIN_URL}/signup?ref=${referralInfo.referral_code}`;
    navigator.clipboard.writeText(signupUrl);
    enqueueSnackbar('Referral link copied!', { variant: 'success' });
    dashboard.actionClicked({
      action_type: 'copy_referral_link',
      source: 'dashboard_v2_card',
    });
  };

  return (
    <FeatureCard
      title="Share JotPsych"
      sx={{ gridColumn: '1 / -1' }}
      contentSx={{ py: 1.5 }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography variant="body1">
          {rewardText.description}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="body1" color="primary.main" sx={{ fontWeight: 700 }}>
            {referralInfo.referral_code}
          </Typography>
          <IconButton
            onClick={handleCopy}
            aria-label="Copy referral link"
            size="small"
            color="primary"
          >
            <ContentCopy fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </FeatureCard>
  );
};

export default ShareJotPsychCard;

